<template>
  <div>
      <div class="container-fluid">
        <div class="page-header">
          <div class="row">
            <div class="col-sm-6">
              <h3>{{$t("transactions")}}</h3>
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>{{$t("general")}}</a></li>
                <li class="breadcrumb-item active">{{$t("transactions")}}</li>
              </ol>
            </div>
            <div class="col-sm-6">
              <!-- Bookmark Start-->
              <div class="bookmark">
                <ul>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                  <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                    <form class="form-inline search-form">
                      <div class="form-group form-control-search">
                        <input type="text" :placeholder="$t('search') + '...'">
                      </div>
                    </form>
                  </li>
                </ul>
              </div>
              <!-- Bookmark Ends-->
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid starts-->
      <div class="container-fluid">
        <div class="col-md-12 p-0 project-list">
          <div class="card">
            <div class="row">
              <div class="col-md-6 p-0">
                <div class="mb-2">
                  <input class="form-control" type="text" v-model="search" @change="fetchPurchases(true)" :placeholder="$t('search') + '...'">
                </div>
              </div>
              <div class="col-md-6 p-0">                    
                <div class="form-group mb-0 me-0"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
                <div class="card">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th v-show="$rights.includes('TENANT_INDEPENDENCE')" scope="col">{{ $t("tenant") }}</th>
                          <th scope="col">{{ $t("name") }}</th>
                          <th scope="col">{{ $t("date") }}</th>
                          <th style="text-align: right" scope="col">{{ $t("value") }}</th>
                          <th style="min-width: 10px">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody v-if="purchases.length > 0">
                        <tr v-for="purchase in purchases" :key="purchase.id">
                          <td v-show="$rights.includes('TENANT_INDEPENDENCE')">{{purchase.tenant.name}}</td>
                          <td>{{purchase.name != null && purchase.name.includes("SUMMARY") ? $t("summary") + " " + purchase.referenceDateFormatted : $t(purchase.name)}}</td>
                          <td>{{$formatDateTime(purchase.createdAt)}}</td>
                          <td v-if="purchase.price >= 0" style="text-align: right" class="green-color">+{{ $formatCurrency(purchase.price) }}€</td>
                            <td v-else style="text-align: right" class="error-color">{{ $formatCurrency(purchase.price) }}€</td>
                          <td style="min-width: 10px">
                            <button class="btn btn-light" v-show="purchase.name != 'BONUS' && purchase.name != 'WELCOME_BONUS'" @click="downloadInvoice(purchase.id)">
                              <download-icon size="16"></download-icon>
                            </button>
                          </td>
                        </tr>
                        <tr v-show="!$rights.includes('TENANT_INDEPENDENCE')">
                          <td :colspan="$rights.includes('TENANT_INDEPENDENCE') ? 3 : 2">&nbsp;</td>  
                          <td style="text-align: right; font-weight: bold">{{ $t("sum") }}: {{ $formatCurrency(currentBudget) }}€</td>
                          <td style="min-width: 10px">
                            &nbsp;
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <td colspan="5">{{ $t("no_entries") }}</td>
                      </tbody>
                    </table>
                  </div>
                </div>
          </div>
        </div>
      </div>
      <div style="position:absolute; bottom: 100px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
      <!-- Container-fluid Ends-->
    
  </div>
</template>

<script>

import pagination from './custom/pagination.vue'
import { MapPinIcon,PlusSquareIcon,ClipboardIcon,FileTextIcon,TrashIcon, EditIcon, DownloadIcon } from 'vue-feather-icons'

export default {

  components: {
    MapPinIcon,
    PlusSquareIcon,
    ClipboardIcon,
    FileTextIcon,
    TrashIcon,
    EditIcon,
    DownloadIcon
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 20,
      currentBudget: 0,
      sort: null,
      order: true,
      routes: {
        purchases: "/api/purchase",
      },

      purchases: [],
      search: "",
      convertedTenants: [],
      tenantFilter: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      tenants: [],
      roles: [],
      createTenantPopup: false,
      menu: false,
      createmode: true,

      // Personal Data
      me: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.fetchPurchases();
    this.fetchBudget();
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
          setTimeout(() => {
            var _this = this;
            if(this.page  < this.totalPages){
                    this.page++;
                    this.$axios
                        .get(this.routes.purchases, {
                          params: {
                            search: this.search,
                            sort: this.sort,
                            order: this.order ? "ASC":"DESC",
                            page: this.page -1,
                            size: this.ElementPerPage
                          }
                        })
                        .then(function (response) {
                          if(response.data.content.length >= 1) {
                                response.data.content.forEach(item => _this.purchases.push(item));
                                _this.totalPages = response.data.totalPages;
                            }
                        })
                        .catch(this.onError);
                }
            }, 500);
        }
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchPurchases();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchPurchases();
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchBudget() {
      var _this = this;
      this.$axios
        .get("/api/purchase/budget")
        .then(function (response) {
          _this.currentBudget = response.data;
        })
        .catch(this.onError);
    },
    fetchPurchases(resetPage = false) {
      if(resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.purchases, {
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC":"DESC",
            page: _this.page -1,
            size: _this.ElementPerPage
          }
        })
        .then(function (response) {
          _this.purchases = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    updatePage() {
      this.fetchPurchases();
    },
    downloadInvoice(purchaseId){
      var win = window.open("/api/purchase/invoice/" + purchaseId, "_blank");
      win.focus();
    }
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>

